export function useProtectedRoute() {
    const isAuth = () => {
        const token = localStorage.getItem('token');
        if (token == null) { return false; }
        return true;
    }

    return {
        isAuth
    }
}